var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.BFormGroup,
    [
      _c(_setup.BFormSelect, {
        attrs: {
          options: _setup.sizeOptions,
          value: _setup.props.value,
          size: "lg",
        },
        on: { input: _setup.onChange },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }